import React from 'react'
import { Grid, Typography, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { dateFormat } from '../utils/formatter'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%'
  },
  tableHeader: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: '#333',
    borderBottom: '1px solid #ddd',
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    textAlign: 'left'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    alignItems: 'left',
    padding: theme.spacing(0.5, 0),
    borderBottom: '1px solid #f0f0f0',
    gap: theme.spacing(1)
  },
  tableCell: {
    fontSize: '0.85rem',
    color: '#666',
    textAlign: 'left'
  },
  tableCellValue: {
    fontSize: '0.85rem',
    color: '#000',
    textAlign: 'left'
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: '#000',
    fontWeight: 'bold'
  }
}))


const formatNumber = (value) => {
  if (!value && value !== 0) return ''
  return value.toString()
}

const ServiceRow = ({ label, date, years, months, days, classes }) => (
  <div className={classes.tableRow}>
    <div className={classes.tableCell}>{label}</div>
    <div className={classes.tableCellValue}>{dateFormat(date)}</div>
    <div className={classes.tableCellValue}>{formatNumber(years)}</div>
    <div className={classes.tableCellValue}>{formatNumber(months)}</div>
    <div className={classes.tableCellValue}>{formatNumber(days)}</div>
  </div>
)

const JobRow = ({ label, serviceDate, years, months, days, classes }) => (
  <div className={classes.tableRow}>
    <div className={classes.tableCell}>{label}</div>
    <div className={classes.tableCellValue}>{dateFormat(serviceDate)}</div>
    <div className={classes.tableCellValue}>{formatNumber(years)}</div>
    <div className={classes.tableCellValue}>{formatNumber(months)}</div>
    <div className={classes.tableCellValue}>{formatNumber(days)}</div>
  </div>
)

export default function LengthOfServiceDisplay({ data }) {
  const classes = useStyles()

  // Get the first row of data if it exists
  const rowData = data && data.length > 0 ? data[0] : {}

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        {/* Length of Service Section */}
        <Grid item xs={12}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h5" className={classes.sectionTitle}>
              Length of Service
            </Typography>
            
            {/* Table Header */}
            <div className={classes.tableRow}>
              <div className={classes.tableHeader}>Category</div>
              <div className={classes.tableHeader}>Date</div>
              <div className={classes.tableHeader}>Years</div>
              <div className={classes.tableHeader}>Months</div>
              <div className={classes.tableHeader}>Total Days</div>
            </div>

            {/* Service Rows */}
            <ServiceRow
              label="Hire"
              date={rowData.date_hired}
              years={rowData.date_hired_years}
              months={rowData.date_hired_months}
              days={rowData.date_hired_days}
              classes={classes}
            />
            
            <ServiceRow
              label="Adjusted Hire"
              date={rowData.adj_hire_date}
              years={rowData.adj_hire_years}
              months={rowData.adj_hire_months}
              days={rowData.adj_hire_days}
              classes={classes}
            />
            
            <ServiceRow
              label="Anniversary"
              date={rowData.annivers_date}
              years={rowData.annivers_years}
              months={rowData.annivers_months}
              days={rowData.annivers_days}
              classes={classes}
            />
            
            <ServiceRow
              label="Seniority"
              date={rowData.senior_date}
              years={rowData.senior_years}
              months={rowData.senior_months}
              days={rowData.senior_days}
              classes={classes}
            />
          </Paper>
        </Grid>

        {/* Job Section */}
        <Grid item xs={12}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h5" className={classes.sectionTitle}>
              Job
            </Typography>
            
            {/* Table Header */}
            <div className={classes.tableRow}>
              <div className={classes.tableHeader}>Job Code</div>
              <div className={classes.tableHeader}>Service Date</div>
              <div className={classes.tableHeader}>Years</div>
              <div className={classes.tableHeader}>Months</div>
              <div className={classes.tableHeader}>Total Days</div>
            </div>

            {/* Job Row */}
            <JobRow
              label={rowData.job_code || 'job_code'}
              serviceDate={rowData.service_date}
              years={rowData.years_in_position}
              months={rowData.months_in_position}
              days={rowData.days_in_position}
              classes={classes}
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}
